'use strict';

angular.module('pmtPlacesApp.directives').directive('pmtLocationEditPermanentlyClosed', [
	'$stateParams',
	'LocationEditService',
	function ($stateParams, LocationEditService) {
		return {
			restrict: 'A',
			replace: true,
			scope: {
				place: '=pmtLocationEditPermanentlyClosed',
				onUpdate: '<',
				onClose: '&',
				openDialog: '='
			},
			link: function (scope) {
				scope.updatePlace = {};
				let site = $stateParams.site,
					setModel = function () {
						scope.updatePlace.permanentlyClosed = scope.place.permanentlyClosed;
					},
					placeUpdated = function (data) {
						angular.extend(scope.place, data.place);
						scope.onUpdate(data.workId, data.place);
						scope.openDialog = false;
					},
					errorUpdatePlace = function () {
						scope.showErrorSaving = true;
						scope.showSavingProgress = false;
					};

				scope.updateAll = function () {
					scope.showSavingProgress = true;
					LocationEditService.updateAllPartial(site, scope.place._id, scope.updatePlace).then(
						placeUpdated,
						errorUpdatePlace
					);
				};

				scope.save = function () {
					if (scope.updatePlace.permanentlyClosed !== scope.place.permanentlyClosed) {
						scope.showSavingProgress = true;
						LocationEditService.savePartial(site, scope.place._id, scope.updatePlace).then(
							placeUpdated,
							errorUpdatePlace
						);
					} else {
						scope.openDialog = false;
						scope.onClose();
					}
				};

				scope.cancel = function () {
					scope.updatePlace = {};
					scope.openDialog = false;
					scope.onClose();
				};

				scope.$watch('openDialog', function (newVal) {
					if (newVal) {
						scope.showSavingProgress = false;
						scope.showErrorSaving = false;
						setModel();
					}
				});
			},
			templateUrl:
				'shared/location/edit/permanentlyClosed/pmtLocationEditPermanentlyClosedView.html'
		};
	}
]);
